import { fetchMentions } from "../utils";
import { EditorMentionsRoot } from "../embeds/root";

export const useMentionHandler = ({
  applicationId,
  propertyName
}: {
  applicationId?: string;
  propertyName?: string;
}) => {
  return {
    searchCallback: (query: string) => {
      return fetchMentions({ query, applicationId, propertyName });
    },
    renderComponent: (props) => <EditorMentionsRoot {...props} />
  };
};
